import React from "react";
import "../styles/contact.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Contact: React.FC = () => {
  return (
    <>
      <header
        className="hero"
        style={{
          backgroundImage: "url(/images/header.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "50vh",
          minHeight: 0,
          overflow: "hidden"
        }}
      >
        <Navbar />
        <div className="hero-content">
          <div className="hero-text">
            <h1>İletişim</h1>
          </div>
        </div>
      </header>
      {/* İletişim içeriği buraya eklenebilir */}
      <section className="contact-section single-column">
        <div className="contact-info">
          <h2>Bize Ulaşın</h2>
          <div className="contact-details">
            <div><span role="img" aria-label="location">📍</span> <strong>Adres:</strong> Sancaktepe, İstanbul</div>
            <div><span role="img" aria-label="phone">📞</span> <strong>Telefon:</strong> <a href="tel:+905324661329">+90 532 466 13 29</a></div>
            <div><span role="img" aria-label="mail">✉️</span> <strong>E-posta:</strong> <a href="mailto:info@timelektrik.com">info@timelektrik.com</a></div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Contact; 